<template>
  <div class="space-y-16">
    <mia-settings-basics-texts-general-form v-if="!isB2u" />

    <mia-has-feature feature="connect_onboarding">
      <mia-texts-connect-onboarding-form />
    </mia-has-feature>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextsGeneralForm from '@/components/settings/forms/TextsGeneralForm.vue'
import TextsConnectOnboardingForm from '@/components/settings/forms/TextsConnectOnboardingForm.vue'

export default {
  name: 'MiaSettingsBasicsPublishing',

  components: {
    'mia-settings-basics-texts-general-form': TextsGeneralForm,
    'mia-texts-connect-onboarding-form': TextsConnectOnboardingForm
  },

  computed: {
    ...mapGetters('settings', ['isB2u'])
  }
}
</script>
